/**
 * SPDX-FileCopyrightText: (c) 2026 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import React, {useContext} from 'react';

export enum Scope {
	Head = 'head',
	Body = 'body',
}

export const ScopeContext = React.createContext<Scope>(Scope.Head);

export function useScope() {
	return useContext(ScopeContext);
}
